const monthNames = [
  'Januar',
  'Februar',
  'Mars',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Desember',
]

export function formatTerms(terms: string[]) {
  return terms.map((term: string) => {
    const dateStr = term.split('T')[0]
    const date = new Date(dateStr)

    return {
      value: dateStr,
      label: `${monthNames[date.getMonth()]} ${date.getFullYear()}`,
    }
  })
}

export function formatFleetTerms(terms: { termPeriod: string }[]) {
  return terms?.map((term) => {
    const dateStr = term?.termPeriod?.split('T')[0]
    const date = new Date(dateStr)

    return {
      value: dateStr,
      label: `${monthNames[date.getMonth()]} ${date.getFullYear()}`,
    }
  })
}

const padMonth = (month: string | number) => String(month).padStart(2, '0')
const todayDate = () => new Date().toISOString().substring(0, 10)

export const todayDateTime = () => `${todayDate()}T00:00:00Z`
export const monthInputValue = (date: string) => date.substring(0, 7)
export const todayMonth = () => monthInputValue(todayDate())

export const subOneYearMonth = (value: string, type: 'date' | 'month' = 'month') => {
  const date = type === 'date' ? valueToDate(value, 'date') : new Date(`${value}-01T00:00:00`)
  date.setMonth(date.getMonth() - 12)

  const year = date.getFullYear()
  const month = padMonth(date.getMonth() + 1)
  const day = String(date.getDate()).padStart(2, '0')

  return type === 'date' ? dateToValue(new Date(`${year}-${month}-${day}T00:00:00`), 'date') : `${year}-${month}`
}

export const isInRange = (value: string, from: string, to: string) => {
  if (!value || !from || !to) return true
  return value >= from && value <= to
}

export const periodValue = (year: string | number, month: string | number) => `${year}-${padMonth(month)}`

export const valueToDate = (value: string, type: 'date' | 'month') => {
  if (!value) return new Date()
  if (type === 'date' && value.includes('T')) return new Date(value)
  const normalizedValue = type === 'date' ? value : `${value}-01`
  return new Date(`${normalizedValue}T00:00:00`)
}

export const dateToValue = (date: Date, type: 'date' | 'month') => {
  if (type === 'date') {
    const year = date.getFullYear()
    const month = padMonth(date.getMonth() + 1)
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}T00:00:00Z`
  }

  const year = date.getFullYear()
  const month = padMonth(date.getMonth() + 1)

  return `${year}-${month}`
}
